module.exports = __webpack_public_path__ + "img/003_04.cd17ca0c.jpg";